import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { UploadComponent } from '../upload/upload.component';
import { UploadPreviewComponent } from '../upload-preview/upload-preview.component';

/**
 * The v2 image-upload field: dropzone → filled preview with a remove button,
 * composed from the shared UploadComponent (logic + v2 error label) and
 * UploadPreviewComponent (file/preview state, hidden). This is the single
 * reusable surface for image uploads — the same look the coupons, novosti and
 * setup-wizard screens established. Hosts reach the inner widgets through the
 * public `upload` / `preview` references (e.g. to preload an existing image
 * with `preview.setPreviewImageFromUrl(...)`).
 */
@Component({
  selector: 'app-image-upload-field',
  templateUrl: './image-upload-field.component.html',
  styleUrls: ['./image-upload-field.component.scss'],
})
export class ImageUploadFieldComponent {
  /** Dropzone headline (e.g. "Povucite sliku ili kliknite za odabir"). */
  @Input() title = '';
  /** Dropzone icon (Material Icons Round name). */
  @Input() icon = 'cloud_upload';
  /** Dropzone secondary line (e.g. "PNG ili JPG"). */
  @Input() hint = '';
  /** Title of the delete-confirmation modal (UploadPreviewComponent). */
  @Input() previewTitle = '';
  /** Label/placeholder forwarded to the underlying UploadComponent. */
  @Input() label = '';
  @Input() placeholder = '';
  @Input() required = false;
  /** Alt text for the filled preview image. */
  @Input() alt = '';
  /** Square preview crop (logos) instead of the default banner ratio. */
  @Input() square = false;
  /** Letterbox the preview (object-fit: contain) — for logos with whitespace. */
  @Input() contain = false;
  /** Label of the remove button in the filled state. */
  @Input() removeLabel = '';

  @Output() fileSelected = new EventEmitter<File>();
  @Output() deleted = new EventEmitter<void>();

  @ViewChild('upload') upload: UploadComponent;
  @ViewChild('preview') preview: UploadPreviewComponent;

  public onUpload(file: File): void {
    this.preview.setPreviewImageFromFile(file);
    this.fileSelected.emit(file);
  }

  public onDelete(): void {
    this.upload?.resetInput();
    this.deleted.emit();
  }
}
